import React, { useState, useEffect } from 'react';
import axios from 'axios'; // أضف هذا الاستيراد
import { toast } from 'react-toastify'; // أضف هذا الاستيراد إذا كنت تستخدمه
import 'react-toastify/dist/ReactToastify.css';
import ImageCover from "../assetes/image4.jpg";
import ImageCover1 from "../assetes/image5.jpg";
import ImageCover2 from "../assetes/image6.jpg";
import ImageCover3 from "../assetes/image8.jpg";
import ImageCover4 from "../assetes/image9.jpg";
import ImageCover5 from "../assetes/image11.jpg";
import ImageCover6 from "../assetes/image.jpg";
import logoImg from "../assetes/Suite Logo.png";
import { AnimatePresence, motion } from "framer-motion";
import { CiLocationOn } from "react-icons/ci";
import { CiClock2 } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import 'react-calendar/dist/Calendar.css';
import { DayPicker } from "react-day-picker";
import { de } from "date-fns/locale"; // استيراد اللغة الألمانية
import "react-day-picker/style.css";
import { FaWindowMinimize } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa6";
import CalenderContent from './CalenderContent';
import { MdOutlineTimer } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import { fetchAvailableDays } from '../redux/apiCalls/calenderApiCall';
import { IoCloseSharp } from "react-icons/io5";
import { VscError } from "react-icons/vsc";
import { fetchPrice } from '../redux/slices/PriceSlice';
const images = [ImageCover, ImageCover1, ImageCover2, ImageCover3, ImageCover4, ImageCover5, ImageCover6];
function Calender() {
  window.onload = () => {
    sessionStorage.clear()
    sessionStorage.clear()
  }
  let price = 0;
  const [blockedDays, setBlockedDays] = useState([]);

  useEffect(() => {
    const fetchBlockedDays = async () => {
      try {
        const response = await axios.get('https://ssl.vipwellness-suite.de/api/orders/unavailable-days');
        // التعديل: تحويل التواريخ إلى UTC
        const blockedDates = response.data.map(day => {
          const date = new Date(day.date);
          return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
            .toISOString().split('T')[0];
        });
        setBlockedDays(blockedDates);
      } catch (error) {
        console.error("Error fetching blocked days:", error);
      }
    };
    fetchBlockedDays();
  }, []);
  // دالة التحقق من الأيام المعطلة
  const isBlockedDay = (day) => {
    const utcDate = new Date(Date.UTC(day.getFullYear(), day.getMonth(), day.getDate()));
    return blockedDays.includes(utcDate.toISOString().split('T')[0]);
  };

  // دالة التحقق من الأيام السابقة للأيام المعطلة
  const isPreviousOfBlockedDay = (day) => {
    const dayStr = day.toISOString().split('T')[0];
    return previousBlockedDays.includes(dayStr);
  };

  // دالة مشتركة للتحقق
  const shouldDisableDay = (day) => {
    return isBlockedDay(day) || isPreviousOfBlockedDay(day);
  };
  const isPastOrBlockedDay = (day) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dayDate = new Date(day);
    dayDate.setHours(0, 0, 0, 0);

    return dayDate < today || blockedDays.includes(dayDate.toISOString().split('T')[0]);
  };

  const [toastMessage, setToastMessage] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(null);
  let x = selectedDate
  const [selectedDauer, setSelectedDauer] = useState('Stunde');
  const [flag, setFlag] = useState(false)
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [endTime1, setendTime] = useState(false);
  const [standort, setStandort] = useState(false);
  const [dauer, setDauer] = useState(false);
  const [time, setTime] = useState(false);
  const [adults, setAdults] = useState(0);
  const [selectedTime, setSelectedTime] = useState(null); // بدلاً من "Timer"
  const [previousBlockedDays, setPreviousBlockedDays] = useState([]);

  // 
  useEffect(() => {
    dispatch(fetchPrice())
  }, [dispatch])
  const { Pricing } = useSelector(state => state.Price)
  const orderDate = new Date(selectedDate);
  const dayOfWeek = orderDate.getUTCDay(); // 0 (Sunday) to 6 (Saturday)
  // Pricing logic based on day of the week and number of people
  if (dayOfWeek >= 1 && dayOfWeek <= 4) {
    // Monday to Thursday
    const arr = Pricing?.weekday;
    arr?.map(e => {
      if (adults >= e.from && adults <= e.to) {
        price = e.price
      }
    })


  } else {
    // Friday to Sunday
    const arr = Pricing?.weekend;
    arr?.map(e => {
      if (adults >= e.from && adults <= e.to) {
        price = e.price
      }
    })

  }
  sessionStorage.setItem('priceFirst', price);
  const availableDays = useSelector((state) => state.combined?.availableDays || []);
  const filterDate = availableDays?.filter(el => el?.date === x)
  let y = []
  filterDate.map(el => el?.bookingStarts ? y = el?.bookingStarts : '')
  sessionStorage.setItem('date', x)
  sessionStorage.setItem('adults', adults)
  let str = `${selectedDauer}`
  useEffect(() => {
    const startTime = selectedTime || "09:00"; // استخدام القيمة الافتراضية إذا لم يتم تحديد وقت البدء
    const endTime = calculateEndTime(startTime, str); // حساب وقت النهاية
    sessionStorage.setItem('endTime', endTime)
    dispatch(fetchAvailableDays({ startTime, endTime, selectedDauer })) // تمرير startTime و endTime
      .unwrap()
      .then(() => setLoading(false))
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [dispatch, selectedTime, selectedDauer]); // إضافة selectedTime و selectedDauer كمتابعات

  useEffect(() => {
    if (selectedTime && selectedDauer) {
      calculateEndTime(); // حساب الوقت النهائي عند تغيير selectedTime أو selectedDauer
    }
  }, [selectedTime, selectedDauer]); // إضافة selectedDauer هنا

  const calculateEndTime = () => {
    if (!selectedTime || selectedDauer <= 0) return null;

    const [hours, minutes] = selectedTime.split(":").map(Number);
    const totalMinutes = hours * 60 + minutes + selectedDauer * 60;
    const endHours = Math.floor(totalMinutes / 60);
    const endMins = totalMinutes % 60;

    // تحديد الوقت الأقصى إلى 22:30
    const maxHours = 22;
    const maxMinutes = 30;

    if (endHours > maxHours || (endHours === maxHours && endMins > maxMinutes)) {
      return `${String(maxHours).padStart(2, "0")}:${String(maxMinutes).padStart(2, "0")}`;
    }

    return `${String(endHours).padStart(2, "0")}:${String(endMins).padStart(2, "0")}`;
  };

  // حساب وقت النهاية وتخزينه في sessionStorage
  const endTime = calculateEndTime();
  if (endTime) {
    sessionStorage.setItem("endTime", endTime);
  }

  const handleDaySelect = (date) => {
    if (!date) {
      setSelectedDate(null);
      return;
    }

    const selectedUtcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dateStr = selectedUtcDate.toISOString().split('T')[0];

    if (blockedDays.includes(dateStr)) {
      toast.error("هذا اليوم غير متاح للحجز");
      return;
    }

    setSelectedDate(dateStr);
  };
  const disabledDays = availableDays
    .filter((day) => day.bookingStarts.length === 0)
    .map((day) => new Date(day.date));

  const modifiers = {
    a47a24: availableDays
      .filter((day) => day.bookingStarts.length > 0)
      .map((day) => new Date(day.date)),
  };
  // تخصيص أنماط الموديفايزر
  const modifiersStyles = {
    a47a24: { backgroundColor: "#a47a24", color: "white" }
  };
  // منع اختيار الأيام الماضية
  const isPastDay = (day) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    return day < tomorrow;
  };
  const handleIncreaseAdults = () =>
    setAdults((prev) => prev < 20 ? prev + 1 : prev);

  const handleDecreaseAdults = () =>
    setAdults((prev) => (prev > 1 ? prev - 1 : prev));

  const handleDauerSelection = (value) => {
    const duration = parseInt(value) || 0; // الوقاية من القيم غير الرقمية
    if (duration >= 0) { // تأكيد أن المدة لا تقل عن الصفر
      setSelectedDauer(duration);
      sessionStorage.setItem("selectedDauer", duration);
    }
  };
  const handleIconClick = () => {
    setShowLogin(!showLogin);
  };
  const handleStandortClick = () => {
    setStandort(!standort);
  };
  const handleStartedClick = () => {
    setTime(!time);
  };
  const handleDauerClick = () => {
    setDauer(!dauer);
  };
  const handleConfirmClick = () => {
    if (selectedDauer) {
    } else {
      alert("يرجى اختيار مدة قبل التأكيد.");
    }
    setDauer(false);
  };
  const handleNavigateToLogin = () => {
    navigate("/login");
  };
  const handlePostClick = () => {
    if (!adults) {
      setToastMessage("Bitte wählen Sie die Anzahl der Personen");
      setFlag(true);
    } else if (!x) {
      setToastMessage("Bitte wählen Sie ein Buchungsdatum");
      setFlag(true);
    } else if (!selectedDauer) {
      setToastMessage("Bitte wählen Sie die Buchungsdauer");
      setFlag(true);
    } else if (!selectedTime) { // سيصبح true إذا كانت القيمة null
      setToastMessage("Bitte wählen Sie eine Buchungsuhrzeit");
      setFlag(true);
    } else {
      navigate('./cat');
    }
  };
  const handelClick = () => {
    setStandort(false);
  };
  const handleTimeSelection = (time) => {
    setSelectedTime(time); // سيتم تعيين القيمة الفعلية (مثال: "10:00")
    sessionStorage.setItem("selectedTime", time);
  };
  // const [set, setSet] = useState(0);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setSet((prev) => (prev + 1) % images.length);
  //   }, 10000); 
  //   return () => clearInterval(interval);
  // }, []);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 10000); // تغيير الخلفية كل 4 ثوانٍ

    return () => clearInterval(interval);
  }, []);
  const splitIntoHalfHours = (times) => {
    if (!times || times.length === 0) return [];

    return times.filter(time => {
      const [hours, minutes] = time.split(":").map(Number);
      const totalEndMinutes = (hours * 60 + minutes) + (selectedDauer * 60);
      const endHours = Math.floor(totalEndMinutes / 60);
      const endMins = totalEndMinutes % 60;

      // السماح حتى الساعة 22:30
      return endHours < 22 || (endHours === 22 && endMins <= 30);
    });
  };
  return (
    <div className="relative w-[100%] h-min-[100%] bg-cover flex flex-col justify-between overflow-hidden transition-opacity duration-1000 ease-in-out">
      {images.map((img, i) => (
        <div
          key={i}
          className={`absolute inset-0 w-full h-full bg-cover bg-center transition-opacity duration-1000 ${i === index ? "opacity-100" : "opacity-0"
            }`}
          style={{ backgroundImage: `url(${img})` }}
        />
      ))}
      <div className='mt-[20px] z-[1]'>
        <div className='flex justify-center items-center text-center'>
          <a href="/">
            <img src={logoImg} alt='logo' className='md:w-[150px] w-[100px]' />
          </a>
        </div>
        <h1 className="text-[#fff] font-[700] text-[16px] leading-[1] tracking-[0.025em] uppercase text-center md:text-[48px]">Reserviere deine Wohlfühlpause</h1>
        <h2 className="block text-[#fff] text-[12px] md:text-[1.25rem] leading-[1.75rem] text-center mt-[1.5rem] mb-[1.5rem]">
          Genieße deinen ganz persönlichen Entspannungsmoment
          <br />
          bei VIP Wellness Suite
        </h2>
      </div>
      <div className="flex justify-center md:pt-[20px] z-[100]">
        <div className="md:w-[100%] md:flex md:justify-center grid gap-[15px] md:gap-[10px] w-[100%] pl-[20px] pr-[20px]">
          <div className="rounded-[5px] relative bg-[#fff] w-[100%] md:w-[27%] flex items-center pt-[10px] pb-[10px] pl-[10px] pr-[10px] justify-between">
            <div className="flex">
              <div>
                <CiLocationOn className="text-[19px]" />
              </div>
              <h1 className="font-[600] text-black ml-[10px]" >Gäste</h1>
            </div>
            <p className="text-[rgb(91,91,91)] cursor-pointer" onClick={handleStandortClick}>{adults > 0 ? adults : 'Persone'}</p>
          </div>
          {standort && <div className="overlay" onClick={handleStandortClick}></div>}
          {standort && (
            <div className="absolute top-[27%] md:top-[40%] right-[5%] md:right-[51%] bg-[#fff] w-[90%] md:w-[40%] pl-[10px] pr-[10px] pt-[10px] pb-[10px] rounded-[5px] z-[10000]">
              <div className="flex justify-between w-[100%]">
                <div className="flex" id='flexid'>
                  <div id='Gäste2'>
                    <svg id='Gäste' className='w-[10px]' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 23" class="h-full"><path fill="currentColor" d="M18 23v-8.332H.006L0 22.989l2.232-.024.007-6.126 13.554.056V23H18ZM9 0C5.64 0 2.908 2.692 2.908 6c0 3.309 2.733 6 6.092 6 3.358 0 6.09-2.691 6.09-6 0-3.308-2.732-6-6.09-6Zm0 9.976C6.774 9.976 4.964 8.192 4.964 6S6.774 2.025 9 2.025c2.225 0 4.035 1.783 4.035 3.975S11.225 9.976 9 9.976Z"></path></svg>
                  </div>
                  <h1 className="font-[600] text-black ml-[10px]">Gäste</h1>
                </div>
                <div className='flex items-center cursor-pointer'>
                  <svg onClick={handleStandortClick} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.286 45.286" class="h-4"><path fill="currentColor" d="m40.703 0-18.06 18.06L4.583 0 .001 4.582l18.06 18.06L0 40.703l4.583 4.583 18.06-18.06 18.06 18.06 4.582-4.582-18.06-18.06L45.286 4.583z" data-name="Pfad 664"></path></svg>
                </div>
              </div>
              <div className="mt-[20px]">
                <div className="flex justify-between items-center w-[100%]">
                  <h5 className="uppercase font-[700]">Erwachsene</h5>
                  <div className="flex justify-between w-[25%] items-center">
                    <div className="w-[50%] flex justify-between items-center text-center">
                      <div
                        className="md:w-[50px] md:h-[50px] w-[30px] h-[30px] rounded-[50%] border-[1px] text-center flex justify-center border-[#333] cursor-pointer items-center"
                        onClick={adults > 0 ? handleDecreaseAdults : undefined}
                        style={{ opacity: adults === 0 ? 0.5 : 1 }}
                      >
                        <FaWindowMinimize className="text-[14px]" />
                      </div>
                    </div>

                    <div className='flex justify-center items-center text-center md:mr-[10px] mr-[5px]'>
                      <h1>{adults}</h1>
                    </div>

                    <div className="w-[50%] flex justify-between items-center">
                      <div
                        className={`md:w-[50px] md:h-[50px] w-[30px] h-[30px] rounded-[50%] border-[1px] text-center flex justify-center items-center border-[#333] cursor-pointer ${adults >= 20 ? 'opacity-50 cursor-not-allowed' : ''
                          }`}
                        onClick={adults < 20 ? handleIncreaseAdults : undefined}
                      >
                        <FaPlus className="text-[14px]" />
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div>
                      <p className="text-[rgb(145,145,145)]">Ab 18 Jahren, mindestens ein Gast muss volljährig sein.</p>
                    </div> */}
                <div className='w-[100%] border-b-[1px] border-b-[#777] pt-[30px]'></div>
              </div>
              <div className="flex justify-between w-[97%] mt-[20px]">
                <div></div>
                <div>
                  <button className=" tracking-[0.05em] font-[500] pt-[0.75rem] pb-[0.75rem] pl-[2.5rem] pr-[2.5rem] rounded-[9999px] justify-center flex items-center cursor-pointer bg-[#eae1d5] hover:bg-[#777] transition-all" onClick={handelClick}>Bestätigen</button>
                </div>
              </div>
            </div>
          )}
          <div className="rounded-[5px] md:ml-[10px] bg-[#fff] w-[100%] md:w-[27%] flex items-center pt-[10px] pb-[10px] pl-[10px] pr-[10px] justify-between">
            <div className="flex">
              <div>
                <CiClock2 className="text-[19px]" />
              </div>
              <h1 className="font-[600] text-black ml-[10px]">Dauer</h1>
            </div>
            <p className="text-[rgb(91,91,91)] cursor-pointer" onClick={handleDauerClick}>{selectedDauer !== null ? selectedDauer : 'Stunde'}</p>
          </div>
          {dauer && <div className="overlay" onClick={handleStandortClick}></div>}
          {dauer && (
            <div className="absolute top:[30px] md:top-[40%] right-[5%] md:right-[25%] bg-[#fff] w-[90%] md:w-[40%] pl-[10px] pr-[10px] pt-[10px] pb-[20px] rounded-[5px] z-[10000]">
              <div className="flex justify-between w-[100%]">
                <div className="flex">
                  <div className="flex items-center">
                    <svg className="w-[19px]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 21 21" class="h-full"><path fill="currentColor" d="M10.5 0C4.708 0 0 4.708 0 10.5S4.708 21 10.5 21 21 16.292 21 10.5 16.292 0 10.5 0Zm0 19.406c-4.91 0-8.906-3.996-8.906-8.906S5.59 1.594 10.5 1.594s8.906 3.996 8.906 8.906-3.996 8.906-8.906 8.906Zm.829-9.352 2.954 2.954-1.126 1.127-3.433-3.433V3.837h1.594v6.217h.01Z"></path></svg>
                  </div>
                  <h1 className="font-[500] text-black ml-[10px]">Dauer</h1>
                </div>
                <div className='flex items-center cursor-pointer'>
                  <svg onClick={handleDauerClick} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.286 45.286" class="h-4"><path fill="currentColor" d="m40.703 0-18.06 18.06L4.583 0 .001 4.582l18.06 18.06L0 40.703l4.583 4.583 18.06-18.06 18.06 18.06 4.582-4.582-18.06-18.06L45.286 4.583z" data-name="Pfad 664"></path></svg>
                </div>
              </div>
              <div className="mt-[20px]">
                <div className="flex items-center text-[rgb(145,145,145)] mt-[2.5px] mb-[1rem]">
                  <p className="text-[#333] ml-[10px] text-[14px]">Wie viel Zeit möchtest du dir für deine Entspannung gönnen?</p>
                </div>
                <div className="flex justify-evenly flex-wrap flex-row content-center w-full gap-4">
                  {Array.from({ length: 8 }, (_, index) => {
                    const value = index + 1;
                    return (
                      <button
                        key={value}
                        className={`w-16 h-16 flex items-center justify-center text-lg font-semibold border border-[rgb(36,36,36)] rounded-full cursor-pointer transition-all 
          ${selectedDauer === value ? "bg-[#a47a24] text-white" : "hover:bg-[#a47a24] hover:text-white"}`}
                        onClick={() => handleDauerSelection(value)}
                      >
                        {`${value} Std.`}
                      </button>
                    );
                  })}
                </div>


              </div>
              <div className="flex justify-between w-[97%] mt-[50px] ">
                <div></div>
                <div>
                  <button className=" tracking-[0.05em] font-[500] pt-[0.75rem] pb-[0.75rem] pl-[2.5rem] pr-[2.5rem] rounded-[9999px] justify-center flex items-center cursor-pointer bg-[#eae1d5] hover:bg-[#777] transition-all" onClick={handleConfirmClick}>Bestätigen</button>
                </div>
              </div>
            </div>
          )}
          <div className=" rounded-[5px] relative bg-[#fff] w-[100%] md:w-[27%] flex items-center pt-[10px] pb-[10px] pl-[10px] pr-[10px] justify-between md:ml-[10px]">
            <div className="flex">
              <div>
                <MdOutlineTimer className="text-[19px] " />
              </div>
              <h1 className="font-[600] text-black ml-[10px]" >Start</h1>
            </div>
            <p className="text-[rgb(91,91,91)] cursor-pointer" onClick={handleStartedClick}>
              {selectedTime || "Timer"} {/* سيظهر "Timer" إذا كانت القيمة null */}
            </p>              </div>
          {time && <div className="overlay" onClick={handleStartedClick}></div>}
          {time && (
           <div className="absolute top-[27%] md:top-[40%] right-[5%] md:right-[9%] bg-[#fff] w-[90%] md:w-[45%] pl-[9px] pr-[9px] pt-[9px] pb-[20px] rounded-[5px] z-[10000]">
           <div className="flex justify-between items-center w-full mb-4">
             <div className="flex items-center">
               <svg className="w-6 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 21 21">
                 <path fill="currentColor" d="M10.5 0C4.708 0 0 4.708 0 10.5S4.708 21 10.5 21 21 16.292 21 10.5 16.292 0 10.5 0Zm0 19.406c-4.91 0-8.906-3.996-8.906-8.906S5.59 1.594 10.5 1.594s8.906 3.996 8.906 8.906-3.996 8.906-8.906 8.906Zm.829-9.352l2.954 2.954-1.126 1.127-3.433-3.433V3.837h1.594v6.217h.01Z"/>
               </svg>
               <h1 className="font-semibold text-gray-800 ml-3 text-xl">Check in</h1>
             </div>
             <div className='p-2 hover:bg-gray-100 rounded-full' onClick={handleStartedClick}>
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.286 45.286" className="w-6 h-6 text-gray-600">
                 <path fill="currentColor" d="m40.703 0-18.06 18.06L4.583 0 .001 4.582l18.06 18.06L0 40.703l4.583 4.583 18.06-18.06 18.06 18.06 4.582-4.582-18.06-18.06L45.286 4.583z"/>
               </svg>
             </div>
           </div>
         
           <div className="mt-4">
             <div className="mb-5 px-2">
               <p className="text-gray-800 text-lg font-semibold">Wann ist der Check-in?</p>
             </div>
         
             <div className="flex flex-wrap gap-3 px-0 overflow-y-auto max-h-[50vh]">
               {splitIntoHalfHours(y)
                 .filter(time => {
                   const [hours] = time.split(":").map(Number);
                   return hours < 24;
                 })
                 .map((time, index) => (
                   <button
                     key={index}
                     className={`
                       w-16 h-16 flex items-center justify-center 
                       text-base font-medium rounded-full cursor-pointer 
                       transition-all duration-300 border-2
                       hover:scale-105 transform
                       shrink-0
                       ${selectedTime === time
                         ? "bg-[#a47a24] text-white border-[#a47a24] shadow-xl scale-105"
                         : "border-gray-300 hover:border-[#a47a24] hover:bg-amber-50"
                       }
                     `}
                     onClick={() => handleTimeSelection(time)}
                   >
                     {time}
                   </button>
                 ))}
             </div>
           </div>
         
           <div className="flex justify-end mt-8 pr-2">
             <button 
               className="font-semibold px-10 py-3 rounded-full cursor-pointer 
                 bg-[#a47a24] text-white hover:bg-[#8a6720] 
                 transition-all duration-300 shadow-lg
                 active:scale-95 transform text-lg"
               onClick={handleStartedClick}
             >
               Bestätigen
             </button>
           </div>
         </div>)}
        </div>
      </div>
      <div className="flex justify-center items-center text-center z-[10]">
        <div className="rounded-[5px] w-[100%] m-[20px] md:w-[82%] bg-[#fff] md:mt-[20px] md:mb-[20px] flex flex-col justify-center pl-[20px] pr-[20px]">
          <div className=" w-[100%] flex justify-center mb-[20px] mt-[20px]">
            <DayPicker
              locale={{ ...de, options: { weekStartsOn: 1 } }}
              numberOfMonths={1}
              mode="single"
              selected={selectedDate ? new Date(selectedDate) : null}
              onSelect={handleDaySelect}
              modifiers={{
                blocked: blockedDays.map(day => new Date(day)),
                available: availableDays
                  .filter(day => day.bookingStarts.length > 0)
                  .map(day => new Date(day.date))
              }}
              modifiersStyles={{
                blocked: {
                  backgroundColor: '#ffebee',
                  color: '#c62828',
                  textDecoration: 'line-through',
                  cursor: 'not-allowed'
                },
                available: {
                  backgroundColor: '#a47a24',
                  color: 'white'
                }
              }}

              disabled={day => {
                const utcDay = new Date(Date.UTC(day.getFullYear(), day.getMonth(), day.getDate()));
                return utcDay < new Date() || blockedDays.includes(utcDay.toISOString().split('T')[0]);
              }}

            />
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center flex-grow mb-[50px] z-[2]">
        <button className="
    transition-all 
    duration-300 
    ease-[cubic-bezier(0.4,0,0.2,1)] 
    transform 
    hover:-translate-y-1 
    hover:scale-105 
    hover:shadow-2xl 
    hover:shadow-[#a47a24]/50 
    active:scale-95 
    tracking-[0.05em] 
    uppercase 
    font-[600] 
    md:font-[700] 
    text-[14px] 
    md:text-[19px] 
    pt-[0.75rem] 
    pb-[0.75rem] 
    pl-[2.5rem] 
    pr-[2.5rem] 
    bg-[#a47a24] 
    text-white 
    rounded-[5px] 
    justify-center 
    items-center 
    flex 
    cursor-pointer
    relative
    overflow-hidden
    group
    before:absolute
    before:inset-0
    before:bg-[#ffffff22]
    before:opacity-0
    hover:before:opacity-100
    before:transition-opacity
    before:duration-300"
          onClick={handlePostClick}>
          <span className="relative z-10">Buchen</span>
        </button>
      </div>
      <AnimatePresence>
        {flag && <div className="overlay" onClick={() => { setFlag(false); setToastMessage(null); }}></div>}
        {flag && (
          <motion.div
            onClick={() => { setFlag(false); setToastMessage(null); }}
            exit={{ width: 0, height: 0 }}
            initial={{ width: 0, height: 0 }}
            animate={flag ? { minWidth: '100vw', minHeight: '114vh' } : { width: '0', height: 0, display: 'none' }}
            className='z-[10000] flex justify-center items-center overflow-hidden absolute top-0 left-0 w-screen h-screen'
          >
            <section
              onClick={(e) => e.stopPropagation()}
              className='relative flex flex-col justify-center items-center p-[10px] bg-[#ffffff] w-[90%] h-[39%] md:w-1/2 md:h-1/3 rounded-lg z-[1000000]'
            >
              <VscError className='text-red-600 text-7xl' />
              <h1 className="text-[12px] md:text-[15px] mt-[10px] text-center">
                {toastMessage}
              </h1>
              <IoCloseSharp
                className='text-xl absolute top-4 left-4'
                onClick={() => { setFlag(false); setToastMessage(null); }}
              />
            </section>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
export default Calender